<script setup lang="ts">
import { computed, useSlots } from "vue";
const props = withDefaults(
  defineProps<{
    title?: string;
    variant?: "flat" | "raised" | "lifted" | "sunken" | "brand";
    interactive?: boolean;
    padding?: number | string;
  }>(),
  { variant: "raised" },
);
const slots = useSlots();
const cls = computed(() => [
  "cw-card",
  `cw-card--${props.variant}`,
  props.interactive ? "cw-card--interactive" : "",
]);
const style = computed(() => (props.padding === undefined ? undefined : { padding: props.padding }));
const hasHead = computed(() => Boolean(props.title ?? slots.title ?? slots.action));
</script>
<template>
  <div
    :class="cls"
    :style="style"
  >
    <div
      v-if="hasHead"
      class="cw-card__head"
    >
      <div class="cw-card__title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <slot name="action" />
    </div>
    <slot />
  </div>
</template>
